import { EnViewMode } from '@medlogic/shared/shared-interfaces';
import { IAppMedlogicState } from '@medlogic/medlogic/medlogic-shared-interfaces';

export const selectAppTitle = (state: IAppMedlogicState) => state?.appMedlogic?.title;
export const selectSearch = (state: IAppMedlogicState) => state?.appMedlogic?.search;
export const selectEnViewMode = (state: IAppMedlogicState) => state?.appMedlogic?.enViewMode || EnViewMode.login;
export const selectSplashes = (state: IAppMedlogicState) => state?.appMedlogic?.splashes;
export const selectIsLoading = (state: IAppMedlogicState) => state?.appMedlogic?.isLoading;
export const selectIsMobile = (state: IAppMedlogicState) => state?.appMedlogic?.isMobile;
